
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/[account_id]/televeterinary",
      function () {
        return require("private-next-pages/accounts/[account_id]/televeterinary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/[account_id]/televeterinary"])
      });
    }
  